var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-edit"},[_c('edit',{ref:"addressEdit",attrs:{"api":"addresses","id":_vm.id,"fs":_vm.addressFields},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }